import type { Mapping } from '@/types'
import { getSyllabusUrlFromMappingBySyllabusCodename } from './getSyllabusUrlFromMapping'

export function getUrlFromSlugs(
	slugs: string[],
	additional = '',
	basePath = '/',
) {
	const path = slugs.join('/')
	return basePath + path + additional
}

export function getMappingByCodename(mappings: Mapping[], codename: string) {
	return mappings.find((_mapping) => {
		return _mapping.params.navigationItem?.codename === codename
	})
}

export default function getUrlFromMapping(
	mappings: Mapping[],
	codename: string,
) {
	const mapping = getMappingByCodename(mappings, codename)

	if (!mapping) {
		return undefined
	}

	// OC2-5659: If this is a syllabus, delegate to canonical URL function
	// This ensures multi-KLA syllabuses always use the canonical KLA (kla_default)
	if (mapping.params.navigationItem?.type === 'syllabus') {
		return getSyllabusUrlFromMappingBySyllabusCodename(
			mappings,
			codename,
			false,
		)
	}

	return getUrlFromSlugs(mapping.params.slug, mapping.params.additional)
}
